import { useMemo } from "react";
import { ControlItem } from "./ControlItem";
import { jsx as _jsx } from "react/jsx-runtime";
export function PrepControls(props) { const opts = useMemo(() => { return props.manager.options(); }, [props.manager]); return /*#__PURE__*/ _jsx("table", { children: /*#__PURE__*/ _jsx("tbody", { children: opts.map(o => /*#__PURE__*/ _jsx(ControlItem, { value: o, locked: props.locked })) }) }); }
